import React from 'react';
import LegalPage, { LegalSection, LegalList } from '../components/LegalPage';

const Security: React.FC = () => {
  return (
    <LegalPage
      title="Security"
      lastUpdated="June 13, 2026"
      intro="Security and tenant isolation are foundational to how BlockBoard is built. Here is how we protect your community's data."
    >
      <LegalSection title="How We Protect Your Data">
        <LegalList
          items={[
            'HOA data is isolated and protected from other HOA communities.',
            'Role-based permissions control access to information.',
            'Documents are restricted to authorized users.',
            'Payment information is handled through secure third-party processors.',
            'BlockBoard follows a "minimum data collection" philosophy and does not sell customer data.',
          ]}
        />
      </LegalSection>

      <LegalSection title="Tenant Isolation">
        <p>
          Access controls are enforced on the server for every request. A user authenticated for one
          community cannot read or modify data belonging to another community.
        </p>
      </LegalSection>

      <LegalSection title="Reporting a Concern">
        <p>
          If you believe you have found a security issue, please contact us so we can investigate
          promptly. We appreciate responsible disclosure.
        </p>
      </LegalSection>
    </LegalPage>
  );
};

export default Security;
